"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _SelectKaishaSoshiki = _interopRequireDefault(require("01_core/components/select/SelectKaishaSoshiki"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _SelectGyomuContent = _interopRequireDefault(require("../../common/components/select/SelectGyomuContent"));
var _SelectKansaTgtNendo = _interopRequireDefault(require("../../common/components/select/SelectKansaTgtNendo"));
var _kansaConditionActions = require("../../common/kansaConditionActions");
var _kansaAnswerActions = require("../kansaAnswerActions");
const _excluded = ["gyomuCd"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledCTextField = (0, _styles.styled)(_CTextField.default)(() => ({
  marginTop: 0,
  padding: '0,0,0,0'
}));
class KansaAnswerCondition extends _react.default.Component {
  constructor(props) {
    super(props);
    // 検索ボタン押下時のハンドラ
    _defineProperty(this, "onSearchClick", () => {
      const {
        saveShareCondition,
        searchConditions,
        closeInfoBar,
        fixConditions,
        resetPaging,
        search
      } = this.props;
      if (!search) {
        saveShareCondition(_objectSpread({}, searchConditions));
        fixConditions();
        closeInfoBar();
        resetPaging();
      }
      const _this$props$searchCon = this.props.searchConditions,
        {
          gyomuCd
        } = _this$props$searchCon,
        rest = _objectWithoutProperties(_this$props$searchCon, _excluded);
      let param = _objectSpread(_objectSpread({}, rest), {}, {
        searchContent: gyomuCd
      });
      this.executeSearchAPI(param);
    });
    _defineProperty(this, "executeSearchAPI", sendData => {
      const {
        intl,
        callAPI,
        openInfoBar,
        setSearchResult,
        search
      } = this.props;
      const newSendData = _objectSpread(_objectSpread({}, sendData), {}, {
        onlyBusinessShow: sendData.tantoOnlyFlg
      });
      callAPI(_APIs.KANSA_ANSWER_SEARCH, newSendData).then(json => {
        if (json.status === _APIs.STATUS.SUCCESS) {
          setSearchResult(json.data);
          if (json.data.length === 0) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
            }));
          } else {
            if (!search) {
              // 再検索でない場合のみ一覧へ遷移する制御を行う
              _windowUtil.default.scrollBelowElement(this.area.current);
            }
          }
        }
      });
    });
    // 検索条件変更時のハンドラ
    _defineProperty(this, "handleSearchConditionChange", key => {
      return value => {
        this.props.changeSearchCondition(key, value);
      };
    });
    // 監査部門選択変更時のハンドラ
    _defineProperty(this, "onChangeKaishaSoshikiKansa", obj => {
      this.props.changeSearchCondition('kansaKaishaCd', obj.kaishaCd);
      this.props.changeSearchCondition('kansaBumonCd', obj.soshikiCd);
      this.props.changeSearchCondition('kansaBumonNm', obj.label);
    });
    // 被監査部門選択変更時のハンドラ
    _defineProperty(this, "onChangeKaishaSoshikiHiKansa", obj => {
      this.props.changeSearchCondition('hikansaKaishaCd', obj.kaishaCd);
      this.props.changeSearchCondition('hikansaBumonCd', obj.soshikiCd);
      this.props.changeSearchCondition('hikansaBumonNm', obj.label);
    });
    this.form = /*#__PURE__*/_react.default.createRef();
    this.area = /*#__PURE__*/_react.default.createRef();
  }
  componentDidMount() {
    const {
      search
    } = this.props;
    if (search) {
      this.onSearchClick();
    }
  }
  render() {
    const {
      intl,
      searchConditions,
      selectThemeNm,
      setInitialValue,
      ChangeNendo,
      getCodeItems
    } = this.props;

    // 検索条件
    const conditions = [
    /*#__PURE__*/
    // 業務内容
    _react.default.createElement(_SelectGyomuContent.default, {
      required: true,
      gyomuCdAvail: searchConditions.gyomuCdAvail,
      value: searchConditions.gyomuCd,
      onChange: this.handleSearchConditionChange('gyomuCd')
    }), null,
    /*#__PURE__*/
    // 監査対象年度
    _react.default.createElement(_SelectKansaTgtNendo.default, {
      kansaTgtNendo: String(searchConditions.kansaTgtNendo),
      onChange: ChangeNendo,
      isSelectable: true,
      setInitialValue: setInitialValue
    }),
    /*#__PURE__*/
    // 監査テーマ
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_THEME
      })
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, selectThemeNm)),
    /*#__PURE__*/
    // 監査部門選択
    _react.default.createElement(_SelectKaishaSoshiki.default, {
      kansaTgtNendo: searchConditions.kansaTgtNendo,
      buttonText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_BUMON_SELECT
      }),
      titleText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_BUMON
      }),
      displayLabel: true,
      label: searchConditions.kansaBumonNm,
      kaishaCd: searchConditions.kansaKaishaCd,
      soshikiCd: searchConditions.kansaBumonCd,
      onChange: this.onChangeKaishaSoshikiKansa
    }),
    /*#__PURE__*/
    // 被監査部門選択
    _react.default.createElement(_SelectKaishaSoshiki.default, {
      kansaTgtNendo: searchConditions.kansaTgtNendo,
      buttonText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON_SELECT
      }),
      titleText: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
      }),
      displayLabel: true,
      label: searchConditions.hikansaBumonNm,
      kaishaCd: searchConditions.hikansaKaishaCd,
      soshikiCd: searchConditions.hikansaBumonCd,
      onChange: this.onChangeKaishaSoshikiHiKansa
    }),
    /*#__PURE__*/
    // 監査対象事業名
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_BUSINESS
      })
    }, /*#__PURE__*/_react.default.createElement(StyledCTextField, {
      value: searchConditions.kansaTgtJigyoNm,
      margin: "normal",
      maxLength: 100,
      onChange: this.handleSearchConditionChange('kansaTgtJigyoNm')
    })),
    /*#__PURE__*/
    // 担当の監査対象事業のみ表示
    _react.default.createElement(_Grid.default, {
      "align-items": "center"
    }, /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_ONLY_BUSINESS_SHOW
      }),
      checked: searchConditions.tantoOnlyFlg,
      onChange: this.handleSearchConditionChange('tantoOnlyFlg'),
      shiftLeft: true
    })),
    /*#__PURE__*/
    // 監査回答状況
    _react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_AUDIT_ANSWER_STATUS
      }),
      required: false
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: getCodeItems(_CodeConsts.CODE.KANSA_ANS_STS.KBN),
      selectedOption: searchConditions.answerStatus,
      onSelectOption: this.handleSearchConditionChange('answerStatus')
    }))];

    // オプション検索条件
    const exConditions = null;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.area
    }, /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
      conditions: conditions,
      onSearchClick: this.onSearchClick,
      excConditions: exConditions,
      returnHome: true
    }));
  }
}
const mapStateToProps = state => {
  return {
    searchConditions: state.kansaAnswer.searchConditions,
    search: state.kansaAnswer.search,
    selectThemeNm: state.kansaAnswer.selectThemeNm
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    fixConditions: () => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.FIX_CONDITIONS]()),
    setSearchResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_RESULT](resultList)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    closeInfoBar: () => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.CLOSE]()),
    resetPaging: () => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.RESET_PAGING]()),
    saveShareCondition: condition => dispatch(_kansaConditionActions.kansaConditionActions[_kansaConditionActions.TYPES_CONDITION.SAVE](condition)),
    setInitialValue: (selectNendo, selectThemeNm, preparation) => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_INIT_NENDO](selectNendo, selectThemeNm, preparation)),
    ChangeNendo: (selectNendo, selectThemeNm) => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_NENDO](selectNendo, selectThemeNm))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaAnswerCondition))));